import React from 'react';
import { Link, useLocation } from 'react-router-dom';

const Breadcrumb = () => {
  const location = useLocation();
  const pathSegments = location.pathname.split('/').filter(Boolean);
  
  // Get the current section (household or industrial)
  const currentSection = pathSegments[0] || 'household';
  
  // Only show breadcrumbs for news pages
  if (!pathSegments.includes('news')) return null;

  const handleShare = () => {
    if (navigator.share) {
      navigator.share({
        title: document.title,
        url: window.location.href
      });
    }
  };

  return (
    <nav className="text-[10px] sm:text-xs mb-2 sm:mb-4 max-w-7xl mx-auto px-2 sm:px-6 lg:px-8">
      <div className="flex flex-col sm:flex-row justify-between items-start sm:items-center space-y-2 sm:space-y-0">
        {/* Breadcrumb Navigation */}
        <ol className="flex items-center space-x-1 sm:space-x-2" style={{ fontFamily: "Geogrotesque, sans-serif" }}>
          <li className="flex items-center">
            <Link 
              to={`/${currentSection}/news`}
              className="text-[#D3242A] hover:text-[#B31E23] transition-colors duration-200"
            >
              News
            </Link>
          </li>
          {pathSegments.length > 2 && (
            <>
              <li className="flex items-center">
                <span className="mx-1 sm:mx-2 text-gray-400">/</span>
                <span className="text-gray-600 line-clamp-1 max-w-[150px] sm:max-w-none">
                  {pathSegments[2].split('-').map(word => 
                    word.charAt(0).toUpperCase() + word.slice(1)
                  ).join(' ')}
                </span>
              </li>
            </>
          )}
        </ol>

        {/* Share Button */}
        <button
          onClick={handleShare}
          className="text-[#D3242A] hover:text-[#B31E23] transition-colors duration-200 flex items-center space-x-1"
        >
          <svg width="12" height="12" viewBox="0 0 24 24" fill="currentColor" className="sm:w-4 sm:h-4">
            <path d="M18 16.08c-.76 0-1.44.3-1.96.77L8.91 12.7c.05-.23.09-.46.09-.7s-.04-.47-.09-.7l7.05-4.11c.54.5 1.25.81 2.04.81 1.66 0 3-1.34 3-3s-1.34-3-3-3-3 1.34-3 3c0 .24.04.47.09.7L8.04 9.81C7.5 9.31 6.79 9 6 9c-1.66 0-3 1.34-3 3s1.34 3 3 3c.79 0 1.5-.31 2.04-.81l7.12 4.16c-.05.21-.08.43-.08.65 0 1.61 1.31 2.92 2.92 2.92 1.61 0 2.92-1.31 2.92-2.92s-1.31-2.92-2.92-2.92z"/>
          </svg>
          <span className="text-[10px] sm:text-xs">Share</span>
        </button>
      </div>
    </nav>
  );
};

export default Breadcrumb; 